import React, { useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import Button from '../button';
import classes from './firstScreen.module.css';
import Spinner from '../spinner';

const FirstScreen = ({ url, getData, onClick }) => {
  const [name, setName] = useState(null);
  const [description, setDescription] = useState(null);
  const [isLinkBack, setIsLinkBack] = useState(true);
  const [loading, setLoading] = useState(true);
  const [courseLink, setCourseLink] = useState('');
  const history = useHistory();

  useEffect(() => {
    updateTest()
  }, [])

  const updateTest = () => {
    getData(url).then(({ name, courseLink, description, isLinkBack  }) => {
      setName(name);
      setCourseLink(courseLink);
      setDescription(description);
      setLoading(false);
      setIsLinkBack(isLinkBack)
    });
  }

  const goPreviousPage = (e) => {
    e.preventDefault();
    history.goBack();
  }

  return (
      <>
        {loading ? (
            <Spinner />
        ) : (
            <>
              <h2 className={classes.title}>{name}</h2>
              <p
                  className={classes.description}
                  dangerouslySetInnerHTML={{ __html: description }}
              />
              <div className={`${classes.row} ${!courseLink ? classes.center : ''}`}>
                <Button onClick={onClick} textButton="Начать тест" />
                {courseLink && <a href={courseLink} target="_blank" className="btn">Перейти к курсам</a>}
              </div>
              {isLinkBack &&
              <a onClick={e => goPreviousPage(e)} href="" className="link link_dark link_offset-top">Предыдущий урок</a>}
            </>
        )}
      </>
  );
}

export default FirstScreen;
